"use client"

import { useState, Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import Image from 'next/image'
import logo from "../../../public/heelio_logo.png";

const navigation = [
    { name: 'Solution', href: '/#solution' },
    { name: 'Offres', href: '/#offre' },
    { name: 'Nos cas clients', href: '/#use-case' },
    { name: 'Témoignages', href: '/#client' },
    { name: 'A propos', href: '/a-propos' },
  ]
  

function Header(){
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    const [openModal, setOpenModal] = useState(false)
    const [phone, setPhone] = useState(false)

    return(
    <>
      
      <div className="bg-[#FAFAFA] text-[#042040] ">
      <header className="bg-[#FAFAFA] inset-x-0 top-0 z-50 max-w-[2000px] mx-auto">
        <nav className="h-[80px]  flex items-center justify-between p-6 xl:px-8" aria-label="Global">
          <div className="flex xl:flex-1">
            <a href="/" className="-m-1.5 p-1.5">
              <span className="sr-only">heelio</span>
              <Image
                className="h-8 w-auto"
                src={logo}
                alt="logo heelio"
              />
            </a>
          </div>
          <div className="flex xl:hidden">
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="hidden xl:flex xl:gap-x-12">
            {navigation.map((item) => (
              <a key={item.name} href={item.href} className="text-sm font-semibold leading-6 text-gray-900">
                {item.name}
              </a>
            ))}
          </div>
          <div className="hidden xl:flex xl:flex-1 xl:justify-end space-x-8 items-center">
            <a href="https://app.heelio.tech/login" className="text-sm font-semibold leading-6 text-gray-900 py-1 border-b-2 border-[#FED90F33] hover:border-[#FED90F] font-semibold ease-in-out duration-500">
              Se connecter
            </a>

            <div className='relative w-fit h-fit group cursor-pointer'>
                  <div className='absolute top-0 left-0 rounded-md bg-[#FED90F66] w-full h-full transform translate-x-2 translate-y-2 group-hover:translate-y-1 group-hover:translate-x-1 ease-in-out duration-500'></div>
                  
                  <div className="z-10 w-fit rounded-md px-3.5 py-2.5 border border-1 border-[#042040] relative transform translate-y-0 translate-x-0 group-hover:translate-y-1 group-hover:translate-x-1 ease-in-out duration-500">
                      <p
                          onClick={() => setOpenModal(true)}
                          className=" w-full h-full rounded-md text-sm font-bold tracking-wider text-[#042040] "
                      >
                          Nous contacter
                      </p>
                  </div>
              </div>
          </div>
        </nav>
        <Transition.Root show={mobileMenuOpen} as={Fragment}>

        <Dialog as="div" className="xl:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>

          <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
                >
                <div className="z-[100] fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-[101]">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                    as={Fragment}
                    enter="transhtmlForm transition ease-in-out duration-500 sm:duration-700"
                    enterFrom="translate-x-full"
                    enterTo="translate-x-0"
                    leave="transhtmlForm transition ease-in-out duration-500 sm:duration-700"
                    leaveFrom="translate-x-0"
                    leaveTo="translate-x-full"
                >
                <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
                    <div className="flex items-center justify-between">
                    <a href="#" className="-m-1.5 p-1.5">
                        <span className="sr-only">heelio</span>
                        <Image
                        className="h-8 w-auto"
                        src={logo}
                        alt="logo heelio"
                        />
                    </a>
                    <button
                        type="button"
                        className="-m-2.5 rounded-md p-2.5 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                    >
                        <span className="sr-only">Close menu</span>
                        <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                    </div>
                    <div className="mt-6 flow-root">
                    <div className="-my-6 divide-y divide-gray-500/10">
                        <div className="space-y-2 py-6">
                        {navigation.map((item) => (
                            <a
                            onClick={() => setMobileMenuOpen(false)}
                            key={item.name}
                            href={item.href}
                            className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                            >
                            {item.name}
                            </a>
                        ))}
                        </div>
                        <div className="py-6">
                        <a
                            href="https://app.heelio.tech/login"
                            className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                        >
                            Se connecter
                        </a>
                        <p
                            onClick={() => setOpenModal(true)}
                            className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                        >
                            Nous contacter
                        </p>
                        </div>
                    </div>
                    </div>
                </Dialog.Panel>
                </Transition.Child>
                </div>
                </div>
        </Dialog>
        </Transition.Root>

        <Transition.Root show={openModal} as={Fragment}>
            <Dialog as="div" className="relative z-[120]" onClose={() => {
                setOpenModal(false)
                }}>
                <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
                >
                <div className="z-[120] fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity backdrop-blur-sm" />
                </Transition.Child>

                <div className="fixed inset-0 z-[130] overflow-y-auto">
                <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
                    <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                    <Dialog.Panel className="relative transform rounded-lg bg-[#fafafa] text-left shadow-xl transition-all my-10 w-full max-w-[500px] min-h-content">
                        <div className="px-4 mb-10 pt-5 sm:p-6 sm:pb-4">
                            <div 
                                className="flex justify-end cursor-pointer w-full"
                                onClick={() => {
                                    setOpenModal(false)
                                }}
                            >
                                <XMarkIcon className="h-4 w-4 2xl:h-6 2xl:w-6" aria-hidden="true" />
                            </div>
                            <div className="mt-3 text-center sm:mt-0 sm:text-left text-sm 2xl:text-base mb-5">
                                
                                    <>
                                        <Dialog.Title as="h2" className="text-2xl 2xl:text-4xl text-left flex justify-center items-center font-bold leading-6 mb-12 mt-5 text-[#042040]">
                                            Nous&nbsp;
                                            <p className="relative inline-block">
                                              <span className="bg-[#FED90F] w-[125px] 2xl:w-[180px] h-8 2xl:h-12 absolute -top-1 2xl:-top-.5 -left-1 z-1 rounded-lg transform rotate-[-1.5deg]"></span>
                                              <span className="relative">contacter</span>
                                            </p> 
                                        </Dialog.Title>



                                        <div className='flex justify-center items-center flex-col gap-5'>

                                        <a 
                                          href="mailto:cyril@heelio.io"
                                          className='relative w-[50%] h-fit group cursor-pointer'
                                        >
                                            <div className='absolute top-0 left-0 rounded-md bg-[#FED90F33] w-full h-full transform translate-x-2 translate-y-2 group-hover:translate-y-1 group-hover:translate-x-1 ease-in-out duration-500'></div>
                                            
                                            <div className="z-10 w-full rounded-md px-3.5 py-2.5 border border-1 border-[#042040] relative transform translate-y-0 translate-x-0 group-hover:translate-y-1 group-hover:translate-x-1 ease-in-out duration-500">
                                                <div
                                                    className=" w-full h-full rounded-md text-sm font-bold tracking-wider text-[#042040] flex justify-center items-center space-x-5 border-none	outline-none"
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <path d="M4 18L9 12M20 18L15 12M3 8L10.225 12.8166C10.8665 13.2443 11.1872 13.4582 11.5339 13.5412C11.8403 13.6147 12.1597 13.6147 12.4661 13.5412C12.8128 13.4582 13.1335 13.2443 13.775 12.8166L21 8M6.2 19H17.8C18.9201 19 19.4802 19 19.908 18.782C20.2843 18.5903 20.5903 18.2843 20.782 17.908C21 17.4802 21 16.9201 21 15.8V8.2C21 7.0799 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V15.8C3 16.9201 3 17.4802 3.21799 17.908C3.40973 18.2843 3.71569 18.5903 4.09202 18.782C4.51984 19 5.07989 19 6.2 19Z" stroke="#042040" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                      </svg>
                                                      <p className='mt-1'>Email</p>
                                                </div>
                                            </div>
                                        </a>


                                        <div 
                                          onClick={() => setPhone(true)}
                                          className='relative w-[50%] h-fit group cursor-pointer'
                                        >
                                            <div className='absolute top-0 left-0 rounded-md bg-[#FED90F33] w-full h-full transform translate-x-2 translate-y-2 group-hover:translate-y-1 group-hover:translate-x-1 ease-in-out duration-500'></div>
                                            
                                            <div className="z-10 w-full rounded-md px-3.5 py-3 border border-1 border-[#042040] relative transform translate-y-0 translate-x-0 group-hover:translate-y-1 group-hover:translate-x-1 ease-in-out duration-500 text-center">
                                                {phone ? 
                                                  <a
                                                    href="tel:+33662677951"  
                                                    className='text-[#042040] font-semibold '
                                                  >06 62 67 79 51</a>
                                                :
                                                  <>
                                                    <p className='cursor-pointer px-5 text-[#042040] font-bold flex justify-center items-center gap-3'>
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M16.5562 12.9062L16.1007 13.359C16.1007 13.359 15.0181 14.4355 12.0631 11.4972C9.10812 8.55901 10.1907 7.48257 10.1907 7.48257L10.4775 7.19738C11.1841 6.49484 11.2507 5.36691 10.6342 4.54348L9.37326 2.85908C8.61028 1.83992 7.13596 1.70529 6.26145 2.57483L4.69185 4.13552C4.25823 4.56668 3.96765 5.12559 4.00289 5.74561C4.09304 7.33182 4.81071 10.7447 8.81536 14.7266C13.0621 18.9492 17.0468 19.117 18.6763 18.9651C19.1917 18.9171 19.6399 18.6546 20.0011 18.2954L21.4217 16.883C22.3806 15.9295 22.1102 14.2949 20.8833 13.628L18.9728 12.5894C18.1672 12.1515 17.1858 12.2801 16.5562 12.9062Z" fill="#042040"/>
                                                    </svg>
                                                    <span>Téléphone</span>
                                                    </p>
                                                  </>
                                                }
                                            </div>
                                        </div>

                                        <a 
                                          href="https://zcal.co/heelio/decouverte"
                                          target='_blank'
                                          rel="noopener noreferrer"
                                          className='relative w-[50%] h-fit group cursor-pointer'
                                        >
                                            <div className='absolute top-0 left-0 rounded-md bg-[#FED90F33] w-full h-full transform translate-x-2 translate-y-2 group-hover:translate-y-1 group-hover:translate-x-1 ease-in-out duration-500'></div>
                                            
                                            <div className="z-10 w-full rounded-md px-3.5 py-3 border border-1 border-[#042040] relative transform translate-y-0 translate-x-0 group-hover:translate-y-1 group-hover:translate-x-1 ease-in-out duration-500">
                                                <div
                                                    className=" w-full h-full rounded-md text-sm font-bold tracking-wider text-[#042040] flex justify-center items-center space-x-5 border-none	outline-none"
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12 17C15.866 17 19 13.866 19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10C5 13.866 8.13401 17 12 17ZM12 17V21M7 21H12M12 21H17M15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10Z" stroke="#042040" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                    <p>Visioconférence</p>
                                                </div>
                                            </div>
                                        </a>

                                      </div>
                                       
                                        
                                        
                                    </>  
                            </div>
                        </div>           
                    </Dialog.Panel>
                    </Transition.Child>
                </div>
                </div>
            </Dialog>
            </Transition.Root>
      </header>
      </div>
    </>
    )
}

export default Header;